<div id="legacy-redirect-landing-page-container" class="heading-container">
  <div class="search-info-icon">
    <sdps-icon class="search-icon" color="primary" type="functional" name="search" size="medium"></sdps-icon>
    <sdps-icon class="info-icon" color="information" type="functional" name="info" size="small"></sdps-icon>
  </div>
  <span>Select a valid sub-account to proceed, or select a master-account to access the master account view</span>
</div>
